import type React from 'react';
import { memo } from 'react';
import styled, { css } from 'styled-components';

import { LINK_COLOR, SIZES, TYPES } from '@front/common/src/constants/link';
import type { CommonTextButtonProps } from '@front/common/src/types/components';

import { FONT_WEIGHTS } from '../base-text/base-text';
import Text from '../base-text/variants/text';
import type { TextVariantProps } from '../base-text/variants/type';
import { linkStyle } from '../link/common';
import { StylelessButton } from '../utils';

export const disabledStyle = css`
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const StyledButton = styled(StylelessButton)<{ $color: string }>`
  ${({ $color }) => linkStyle($color)}
  ${disabledStyle};
`;

const TEXT_VARIANT_BY_SIZE: Record<NonNullable<TextButtonProps['size']>, React.FC<TextVariantProps>> = {
  md: Text.MDMedium,
  sm: Text.SMMedium,
  xs: Text.XSMedium,
};

// TODO replace onClick with onPress
export type TextButtonProps = CommonTextButtonProps & {
  label?: string;
  isDisabled?: boolean;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const TextButton = ({
  children,
  isDisabled = false,
  label,
  onClick,
  className,
  type = 'normal',
  size = 'md',
}: TextButtonProps) => {
  const textColor = LINK_COLOR[type];
  const TextVariant = TEXT_VARIANT_BY_SIZE[size];

  return (
    <StyledButton
      onClick={onClick}
      disabled={isDisabled}
      aria-label={label}
      type='button'
      className={className}
      $color={textColor}
    >
      <TextVariant color={textColor}>{children}</TextVariant>
    </StyledButton>
  );
};

export { FONT_WEIGHTS, SIZES, TYPES };
export default memo(TextButton);
